import {useState} from 'react'

import PropTypes from 'prop-types'

import {useSuiContext} from '@s-ui/react-context'
import useMount from '@s-ui/react-hooks/lib/useMount/index.js'
import {Button, BUTTON_SHAPES, BUTTON_VARIANTS} from '@adv-mt/ui/button'

import {NOTIFICATIONS, useNotify} from '../../notifications.js'
import BaseDrawer from '../BaseDrawer/index.js'
import {useTracking} from './hooks/useTracking.js'
import ComplaintForm from './ComplaintForm.js'
import {COMPLAINT_FORM_ID} from './config.js'

const ReportAdDrawer = ({adId, isProfessional, onClose}) => {
  const {domain, i18n} = useSuiContext()
  const notify = useNotify()

  const [complaintTypeId, setComplaintTypeId] = useState()

  const config = domain.get('config')
  const FORM_ERROR_TYPES = config.get('form').formErrorTypes

  const {trackDrawerFormViewed, trackComplaintReasonSelected, trackComplaintSent, trackComplaintSendingError} =
    useTracking()

  useMount(() => {
    trackDrawerFormViewed({adId})
  })

  const handleChangeTypeSelector = ({complaintTypeId: newComplaintTypeId}) => {
    if (newComplaintTypeId) trackComplaintReasonSelected({adId, complaintTypeId: newComplaintTypeId})
    setComplaintTypeId(newComplaintTypeId)
  }

  const handleSubmit = () => {
    trackComplaintSent({adId, complaintTypeId})
    notify(NOTIFICATIONS.AD_COMPLAINT_SENT)
    onClose()
  }

  const handleError = () => {
    trackComplaintSendingError({adId, complaintTypeId, errorType: FORM_ERROR_TYPES.serverError})
    notify(NOTIFICATIONS.AD_COMPLAINT_ERROR)
  }

  const footer = (
    <Button
      form={COMPLAINT_FORM_ID}
      fullWidth
      type="submit"
      shape={BUTTON_SHAPES.CIRCLE}
      variant={BUTTON_VARIANTS.SOLID}
    >
      {i18n.t('AD_COMPLAINT.SEND_COMPLAINT')}
    </Button>
  )

  return (
    <BaseDrawer footer={footer} onClose={onClose} title={i18n.t('AD_COMPLAINT.TO_COMPLAINT_AD')}>
      <ComplaintForm
        adId={adId}
        complaintTypeId={complaintTypeId}
        isProfessional={isProfessional}
        onChangeComplaintType={handleChangeTypeSelector}
        onError={handleError}
        onSubmit={handleSubmit}
      />
    </BaseDrawer>
  )
}

ReportAdDrawer.displayName = 'ReportAdDrawer'

ReportAdDrawer.propTypes = {
  adId: PropTypes.string.isRequired,
  isProfessional: PropTypes.bool,
  onClose: PropTypes.func.isRequired
}

export default ReportAdDrawer
